<template>
  <b-modal id="rate-for-lecturer-modal" :title="`${currentCategory?.label} theo giảng viên`" hide-footer centered
           size="lg" @show="getApiReportDetail" @hide="resetModal">
    <div class="table-responsive" style="max-height: 500px">
      <table class="table table-bordered table-hover text-nowrap">
        <thead class="thead-light ">
        <tr style="position: sticky; top: 0; z-index: 10">
          <th style="vertical-align: middle">#</th>
          <th style="vertical-align: middle">Giảng viên</th>
          <th style="vertical-align: middle">Nhóm giảng viên</th>
          <th style="vertical-align: middle">Trung tâm</th>
          <th style="cursor: pointer" @click="getApiReportDetail(true, sortType === 'asc' ? 'desc' : 'asc')">
            <div class="th-content" style="display: inline-grid; grid-template-columns: 1fr 1fr; column-gap: 5px; align-items: center;cursor: pointer" >
              <span style="cursor: pointer" >Kết quả</span>
              <div style="display: inline-flex;flex-direction: column" >
                <i class="el-icon-caret-top icon-sort" style="font-size: 14px; cursor: pointer" :class="sortType === 'asc' ? 'active' : ''" @click.stop="getApiReportDetail(true,'asc')"></i>
                <i class="el-icon-caret-bottom icon-sort" style="font-size: 14px; cursor: pointer" :class="sortType === 'desc' ? 'active' : ''" @click.stop="getApiReportDetail(true,'desc')"></i>
              </div>
            </div>
          </th>
        </tr>
        </thead>
        <tbody v-if="tableLoading">
        <tr>
          <td colspan="5" style="text-align: center"><i class="el-icon-loading"></i></td>
        </tr>
        </tbody>
        <tbody v-else-if="resultList.length === 0">
        <tr>
          <td colspan="5" style="text-align: center"><span>Không có dữ liệu</span></td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr v-for="(item, index) in resultList" :key="index">
          <td>{{ item?.rank }}</td>
          <td>{{ item?.lecturer }}</td>
          <td>{{ item?.group }}</td>
          <td>{{ item?.center }}</td>
          <td><span :class="rateTypeCanClick?'click-able':''"
                    @click="rateTypeCanClick && openClassModal(item)">{{ item?.result }}</span></td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- Pagination -->
    <div class="edu-paginate mx-auto text-center d-flex justify-content-between mt-10">
      <div class="spacer"></div>
      <paginate
          v-model="page"
          :page-count="lastPage"
          :page-range="3"
          :margin-pages="1"
          :click-handler="clickPage"
          :prev-text="'Trước'"
          :next-text="'Sau'"
          :container-class="'pagination b-pagination'"
          :pageLinkClass="'page-link'"
          :next-link-class="'next-link-item'"
          :prev-link-class="'prev-link-item'"
          :prev-class="'page-link'"
          :next-class="'page-link'"
          :page-class="'page-item'"
      />
      <div class="right-div mr-10">Tổng số bản ghi: <span style="color:#0066FF">{{ total }}</span></div>
    </div>
    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" style="width: 100px" @click="closeModal">Đóng</button>
    </div>
  </b-modal>
</template>
<script>
import {COMPANY_LEVEL, LECTURER_GROUP_LEVEL, LEVEL_LIST} from "../../../../../core/option/leaderRadarOption";
import {GET_ERROR_REPORT_DETAIL} from "../../../../../core/services/store/report-error/reportError.module";

export default {
  name: "RateForLecturerModal",
  props: {
    currentCategory: {
      type: Object,
    },
    reportFilter: {
      type: Object,
    },
    currentGroup: {
      type: Number | null,
    }
  },
  data() {
    return {
      tableLoading: false,
      page: 1,
      lastPage: 1,
      total: 0,
      resultList: [],
      sortType: 'asc'

    }
  },
  methods: {
    clickPage(p) {
      this.page = p
      this.getApiReportDetail()
    },
    openClassModal(item) {
      this.$emit('openClassroomModal', item?.lecturerId)
    },
    async getApiReportDetail(isSortPage = false,sortType = 'asc') {
      try {
        if (isSortPage) {
          this.page = 1
          this.sortType = sortType
        }
        this.tableLoading = true
        const payload = {
          group_teacher_ids: this.currentGroup ? [this.currentGroup] : this.reportFilter?.groupLecturer,
          teacher_ids: this.reportFilter?.lecturer,
          classroom_ids: this.reportFilter?.classroomId,
          center_ids: this.reportFilter?.centerId,
          course_ids: this.reportFilter?.courseId,
          from_date: this.reportFilter?.timeForData[0],
          to_date: this.reportFilter?.timeForData[1],
          dimension: LEVEL_LIST[LECTURER_GROUP_LEVEL], // tùy API bạn cần
          metric: this.currentCategory?.metric_key,
          page: this.page,
          sort_percent: this.sortType,
        };
        const res = await this.$store.dispatch(GET_ERROR_REPORT_DETAIL, payload)
        const pagination = res?.pagination
        this.page = pagination?.current_page
        this.lastPage = pagination?.last_page
        this.total = pagination?.total
        this.resultList = res?.data?.data.map(item => ({
          rank: item?.rank,
          lecturer: `${item?.dimension_code} - ${item?.dimension_name}`,
          group: item?.extra_info?.teacher_group_name,
          center: item?.extra_info?.center_name,
          result: `${item?.metric_value}%`,
          lecturerId: item?.dimension_id,
        }))

      } catch (e) {

      } finally {
        this.tableLoading = false
      }

    },
    closeModal() {
      this.$bvModal.hide('rate-for-lecturer-modal')
    },
    resetModal() {
      this.tableLoading = false
      this.page = 1
      this.lastPage = 1
      this.total = 0
      this.resultList = []
    }
  },
  computed: {
    rateTypeCanClick() {
      return this.currentCategory?.label !== 'Tỉ lệ lỗi giảng dạy'
    }
  }
}
</script>


<style scoped>
.click-able {
  cursor: pointer;
  color: #0066FF;
}

.click-able:hover {
  font-weight: bold;
}
.icon-sort:hover{
  color: #0066FF;
}
.active{
  color: #0066FF;
}
</style>